import { useEffect } from "react";

/**
 * Closes a dropdown/menu when the user clicks outside `ref`'s element or
 * presses Escape. Shared by the Account menu and both nav dropdowns so the
 * behavior — and its edge cases — only needs to be gotten right once.
 *
 * @param {React.RefObject} ref - ref on the dropdown's wrapping element
 * @param {() => void} onClose - called on outside-click or Escape
 */
export function useClickOutsideAndEscape(ref, onClose) {
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    const handleEscape = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [ref, onClose]);
}
